import Interests from "utils/Interests"
import React from "react"
import { JourneyInterestContainer } from "components/views/fle/journey/JourneyInterestContainer"

const JourneyLearnMoreInterest = ({ history, toDone }) => (
  <JourneyInterestContainer
    title="What do you want to learn more about?"
    toDone={toDone}
    somethingElseNext="/fle/journey/learn-more/something-else"
    history={history}
    interestsToExclude={[Interests.INITIAL_FERTILITY_TESTING]}
  />
)

export { JourneyLearnMoreInterest }
